module.exports = __webpack_public_path__ + "static/OR5s-06eaf81d3d3e5a699aaf5d67c47134cc.jpg";